'use strict'

import axios from 'axios'
import qs from 'qs'
// axios.defaults.withCredentials=true;
axios.interceptors.request.use(config => {
    // loading
    
    // 过期时间
    // let pastTime = localStorage.getItem('pastTime')
    // console.log('pastTime => ', Number(pastTime))
    // if (pastTime) {
    //     if ((+new Date()) > Number(pastTime)) {            
    //         localStorage.removeItem('appkey')
    //         localStorage.removeItem('tuid')
    //     }
        
    // }

    let appkey = localStorage.getItem('appkey')
    let tuid = localStorage.getItem('tuid')
    // console.log('config => ', config)
    if (appkey) {
        config.data.appkey = appkey
    }
    if (tuid) {
        config.data.tuid = tuid
    }
    return config
}, error => {
    return Promise.reject(error)
})

axios.interceptors.response.use(response => {
    return response
}, error => {
    return Promise.resolve(error.response)
})


var AddressURL = 'https://api.databnu.com/';  // 接口公共地址部分-变量//公共地址全局变量 http://io.meinuomoda.com/operate/v1     https://api.vguang.com
function checkStatus(response) {
    // console.log(response)
    // loading
    // 如果http状态码正常，则直接返回数据
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        // if (response.data.ERROR_NO == "-101") {
        //     alert("登陆已过期,请重新登陆!")
        //     window.location.href = "#/login"
        // } else {
        return response
        // }

        // 如果不需要除了data之外的数据，可以直接 return response.data
    }
    // if (response && response.status === 401) {
    //     alert("登陆已过期,请重新登陆!")
    // }
    // // 异常状态下，把错误信息返回去
    // return {
    //     status: -404,
    //     msg: '网络异常'
    // }
}

function checkCode(res) {
    // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
    if (res.status === -404) {
        // alert(res.msg)

    }
    if (res.data && (!res.data.success)) {
        // alert(res.data.error_msg)
    }
    return res
}

export default {
    login(url, data) {
        // const url = 'User/register'
        return axios({
            method: 'post',
            baseURL: AddressURL,
            url,
            data: data,
            timeout: 10000,
            headers: {
                // 'X-Requested-With': 'XMLHttpRequest',
                'content-type': 'application/x-www-form-urlencoded'
            }
        }).then(
            (response) => {
                return checkStatus(response)
            }

        ).catch(
            (res) => {
                return checkCode(res)
            }
        )
    },
    post(url, data) {
        url = url   // +'?token='+localStorage.getItem('token')
        return axios({
            method: 'post',
            baseURL: AddressURL,
            url,
            data: data,
            // timeout: 10000,
            headers: {
                // 'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded;',
            }
        }).then(
            (response) => {
                return checkStatus(response)
            }
        ).catch(
            (res) => {
                return checkCode(res)
            }
        )
    },
    upload(url, data) {
        url = url + '?access_token=' + sessionStorage.getItem('token')
        return axios({
            method: 'post',
            baseURL: AddressURL,
            url,
            data: data,
            // timeout: 10000,
            //          headers: {
            //              'X-Requested-With': 'XMLHttpRequest',
            //              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            //          }
        }).then(
            (response) => {
                return checkStatus(response)
            }
        ).catch(
            (res) => {
                return checkCode(res)
            }
        )
    },
    get(url, params) {
        url = url   // +'?token='+localStorage.getItem('token')
        return axios({
            method: 'get',
            baseURL: AddressURL,
            url,
            params, // get 请求时带的参数
            timeout: 10000000,
            headers: {
                // 'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded'
            }

        }).then(
            (response) => {
                return checkStatus(response)
            }
        ).catch(
            (res) => {
                return checkCode(res)
            }
        )
    },
    put(url, params) {
        url = url + '?access_token=' + sessionStorage.getItem('token')
        return axios({
            method: 'put',
            baseURL: AddressURL,
            url,
            data: qs.stringify(params),
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }).then(
            (response) => {
                return checkStatus(response)
            }
        ).catch(
            (res) => {
                return checkCode(res)
            }
        )
    },
    del(url, params) {
        url = url + '?access_token=' + sessionStorage.getItem('token')
        return axios({
            method: 'delete',
            baseURL: AddressURL,
            url,
            data: qs.stringify(params),
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }).then(
            (response) => {
                return checkStatus(response)
            }
        ).catch(
            (res) => {
                return checkCode(res)
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/api/http.js